'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _classnames = require('classnames'),
    _classnames2 = _interopRequireDefault(_classnames),
    _styles = require('../styles'),
    _propTypes3 = require('../propTypes'),
    _withCommonProps = require('../withCommonProps'),
    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
    _themes = require('../themes'),
    _Label = require('../Label'),
    _Label2 = _interopRequireDefault(_Label),
    _CheckboxIcon = require('./CheckboxIcon'),
    _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon),
    _FormControl = require('../FormControl'),
    _FormControl2 = _interopRequireDefault(_FormControl),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var lineHeight = 1.4,
    Styled = {};
Styled.div = {}, Styled.div.root = _styledComponents2.default.div.withConfig({
  displayName: 'CheckboxControl__root'
})(['', ';display:inline-flex;box-sizing:border-box;align-items:center;width:', ';max-width:100%;vertical-align:top;&.required{display:flex;min-height:', ';padding:', ';background-color:', ';background-image:', ';background-position:', ';background-repeat:no-repeat;background-size:', ';border-color:', ';border-style:', ';border-width:', ';border-radius:', ';}&.invalid{background-image:', ';}'], function (props) {
  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({
    direction: props.dir
  });
}, function (props) {
  return props.sc.fullWidth ? '100%' : (0, _themes.getStyle)('CheckboxControl_width');
}, function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('CheckboxControl_minHeight_' + props.sc.size)(props));
}, function (props) {
  return 'rtl' === props.dir ? '0 12px 0 38px' : '0 38px 0 12px';
}, (0, _themes.getStyle)('CheckboxContainer_backgroundColor'), (0, _themes.getStyle)('CheckboxControl_backgroundImage'), function (props) {
  return (0, _themes.getStyle)('CheckboxControl_backgroundPosition_' + props.sc.size)(props);
}, (0, _themes.getStyle)('CheckboxControl_backgroundSize'), (0, _themes.getStyle)('CheckboxContainer_borderColor'), (0, _themes.getStyle)('CheckboxContainer_borderStyle'), (0, _themes.getStyle)('CheckboxContainer_borderWidth'), (0, _themes.getStyle)('CheckboxContainer_borderRadius'), (0, _themes.getStyle)('CheckboxControl_backgroundImage_invalid')), Styled.input = _styledComponents2.default.input.withConfig({
  displayName: 'CheckboxControl__input'
})(['', ';'], (0, _styles.visuallyHidden)()), Styled.div.checkboxIcon = _styledComponents2.default.div.withConfig({
  displayName: 'CheckboxControl__checkboxIcon'
})(['display:flex;align-items:center;height:', ';'], function (props) {
  return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize * lineHeight);
}), Styled.div.labelContent = _styledComponents2.default.div.withConfig({
  displayName: 'CheckboxControl__labelContent'
})(['display:inline-block;align-self:center;flex-grow:1;margin:', ';line-height:', ';user-select:none;', ';'], function (props) {
  return 'rtl' === props.sc.dir ? '0 10px 0 0' : '0 0 0 10px';
}, lineHeight, function (props) {
  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
}), Styled.div.labelContent.displayName = 'Styled_div_labelContent', Styled.Label = (0, _styledComponents2.default)(_Label2.default).withConfig({
  displayName: 'CheckboxControl__Label'
})(['position:relative;display:flex;font-size:', ';font-weight:', ';cursor:pointer;.required &{width:100%;padding:10px 0;}&.disabled{cursor:default;}'], function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('CheckboxControl_fontSize_' + props.sc.size)(props));
}, (0, _themes.getStyle)('CheckboxControl_fontWeight')), Styled.Label.displayName = 'Styled_Label';

var CheckboxControl = function (_PureComponent) {
  function CheckboxControl() {
    _classCallCheck(this, CheckboxControl);

    var _this = _possibleConstructorReturn(this, (CheckboxControl.__proto__ || Object.getPrototypeOf(CheckboxControl)).call(this));

    return _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.renderContent = _this.renderContent.bind(_this), _this;
  }

  return _inherits(CheckboxControl, _PureComponent), _createClass(CheckboxControl, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef && this.props.onRef(this);
    }
  }, {
    key: 'getValidationMessage',
    value: function getValidationMessage(validity) {
      var i18n = this.props.theme.vstui.i18n;
      return validity.valueMissing ? i18n.t('form.missingCheckbox') : '';
    }
  }, {
    key: 'validate',
    value: function validate(callback) {
      this.formControl.validate(callback);
    }
  }, {
    key: 'handleFormControlRef',
    value: function handleFormControlRef(node) {
      this.formControl = node;
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate(validity) {
      var _ref2 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          callback = _ref2.callback,
          onlyValidateIfValid = _ref2.onlyValidateIfValid,
          _ref = arguments[2],
          checked = _ref.checked,
          updateValidationState = _ref.updateValidationState,
          value = _ref.value,
          _props = this.props,
          onValidate = _props.onValidate,
          validate = _props.validate,
          passedDefaultValidation = validity.valid,
          defaultValidationMessage = this.getValidationMessage(validity, {
        checked: checked,
        value: value
      }),
          customValidationMessagePromise = Promise.resolve(validate ? validate(value) : ''),
          update = function update(valid, validationMessage) {
        (!onlyValidateIfValid || onlyValidateIfValid && valid) && updateValidationState(valid, validationMessage, onValidate);
      };

      update(passedDefaultValidation, defaultValidationMessage), passedDefaultValidation ? customValidationMessagePromise.then(function (customValidationMessage) {
        var passedCustomValidation = !customValidationMessage;
        update(passedCustomValidation, customValidationMessage), callback && callback(passedCustomValidation, customValidationMessage);
      }) : callback && callback(passedDefaultValidation, defaultValidationMessage);
    }
  }, {
    key: 'renderContent',
    value: function renderContent(_ref3) {
      var checked = _ref3.checked,
          checkedFormControlValue = _ref3.checkedFormControlValue,
          defaultChecked = _ref3.defaultChecked,
          focused = _ref3.focused,
          invalid = _ref3.invalid,
          handleBlur = _ref3.handleBlur,
          handleChange = _ref3.handleChange,
          handleFocus = _ref3.handleFocus,
          handleNativeFormControlRef = _ref3.handleNativeFormControlRef,
          _props2 = this.props,
          classNameProp = _props2.className,
          commonProps = _props2.commonProps,
          disabled = _props2.disabled,
          fullWidth = _props2.fullWidth,
          id = _props2.id,
          inheritStyles = _props2.inheritStyles,
          label = _props2.label,
          labelHidden = _props2.labelHidden,
          labelledBy = _props2.labelledBy,
          nativeFormControlRefIgnored = _props2.nativeFormControlRef,
          onBlurIgnored = _props2.onBlur,
          onChangeIgnored = _props2.onChange,
          onValidateIgnored = _props2.onValidate,
          required = _props2.required,
          secondary = _props2.secondary,
          size = _props2.size,
          themeProp = _props2.theme,
          validateIgnored = _props2.validate,
          otherProps = _objectWithoutProperties(_props2, ['className', 'commonProps', 'disabled', 'fullWidth', 'id', 'inheritStyles', 'label', 'labelHidden', 'labelledBy', 'nativeFormControlRef', 'onBlur', 'onChange', 'onValidate', 'required', 'secondary', 'size', 'theme', 'validate']),
          theme = (0, _componentTheme2.default)(themeProp),
          i18n = theme.vstui.i18n,
          className = (0, _classnames2.default)(classNameProp, {
        invalid: invalid,
        required: required
      }),
          conditionalProps = {};

      return invalid && (conditionalProps['aria-invalid'] = !0), required && (conditionalProps['aria-required'] = !0), _react2.default.createElement(Styled.div.root, _extends({}, commonProps, {
        className: className,
        sc: {
          fullWidth: fullWidth,
          inheritStyles: inheritStyles,
          size: size
        },
        theme: theme
      }), _react2.default.createElement(Styled.input, _extends({}, otherProps, conditionalProps, {
        "aria-labelledby": labelledBy,
        checked: checkedFormControlValue,
        defaultChecked: defaultChecked,
        disabled: disabled,
        id: id,
        innerRef: handleNativeFormControlRef,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        required: required,
        theme: theme,
        type: 'checkbox'
      })), _react2.default.createElement(Styled.Label, {
        disabled: disabled,
        htmlFor: id,
        inheritStyles: !0,
        sc: {
          size: size
        },
        theme: theme
      }, _react2.default.createElement(Styled.div.checkboxIcon, {
        theme: theme
      }, _react2.default.createElement(_CheckboxIcon2.default, {
        checked: checked,
        disabled: disabled,
        focused: focused,
        invalid: invalid,
        secondary: secondary,
        theme: theme
      })), label && _react2.default.createElement(Styled.div.labelContent, {
        sc: {
          dir: i18n.direction,
          visuallyHidden: labelHidden
        },
        theme: theme
      }, label)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          checked = _props3.checked,
          defaultChecked = _props3.defaultChecked,
          nativeFormControlRef = _props3.nativeFormControlRef,
          onBlur = _props3.onBlur,
          onChange = _props3.onChange,
          theme = _props3.theme;
      return _react2.default.createElement(_FormControl2.default, {
        checked: checked,
        defaultChecked: defaultChecked,
        nativeFormControlRef: nativeFormControlRef,
        onFormControlBlur: onBlur,
        onFormControlChange: onChange,
        onValidate: this.handleValidate,
        ref: this.handleFormControlRef,
        render: this.renderContent,
        theme: theme,
        type: 'checkbox'
      });
    }
  }]), CheckboxControl;
}(_react.PureComponent);

CheckboxControl.propTypes = {
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  commonProps: _propTypes3.commonPropsShape,
  defaultChecked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  inheritStyles: _propTypes2.default.bool,
  label: _propTypes2.default.node,
  labelHidden: _propTypes2.default.bool,
  labelledBy: _propTypes2.default.string,
  nativeFormControlRef: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onRef: _propTypes2.default.func,
  onValidate: _propTypes2.default.func,
  required: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes3.themeShape,
  validate: _propTypes2.default.func
}, CheckboxControl.defaultProps = {
  size: 'medium',
  theme: (0, _themes.createTheme)()
}, CheckboxControl.displayName = 'CheckboxControl';
var CheckboxControlWithTheme = (0, _withCommonProps2.default)(CheckboxControl);
CheckboxControlWithTheme.WrappedComponent = CheckboxControl, exports.default = CheckboxControlWithTheme;